"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hotel = require("../../proptypes/hotel");
var _HotelOfferItem = _interopRequireDefault(require("./HotelOfferItem"));
var _userflow = require("../../utils/userflow");
var _excluded = ["offers", "onClick"];
var HotelOffersList = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var offers = _ref.offers,
    _onClick = _ref.onClick,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledContent, rest, /*#__PURE__*/_react["default"].createElement(OffersContainer, null, offers.map(function (offer) {
    var id = offer.id,
      operatorName = offer.operator_name,
      _offer$extras = offer.extras,
      _offer$extras2 = _offer$extras === void 0 ? {} : _offer$extras,
      cheap = _offer$extras2.cheap,
      instantConfirm = _offer$extras2.instant_confirm,
      cancellationPolicy = _offer$extras2.cancellation_policy,
      ltExtras = offer.lt_extras,
      availability = offer.availability;
    return /*#__PURE__*/_react["default"].createElement(_HotelOfferItem["default"], (0, _extends2["default"])({}, offer, {
      // TODO: убрать rest
      operatorName: operatorName,
      onClick: function onClick() {
        return _onClick(offer);
      },
      key: id,
      hotPrice: cheap,
      instantConfirm: instantConfirm,
      cancellationPolicy: cancellationPolicy,
      included: (0, _userflow.makeIncludedServices)(offer),
      ltExtras: ltExtras,
      availability: availability
    }));
  })));
});
HotelOffersList.displayName = 'HotelOffersList';
var OffersContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelOffersList__OffersContainer",
  componentId: "sc-11f7u8m-0"
})(["display:flex;flex-direction:column;overflow-y:auto;border-radius:4px;width:100%;position:relative;"]);
var StyledContent = _styledComponents["default"].div.withConfig({
  displayName: "HotelOffersList__StyledContent",
  componentId: "sc-11f7u8m-1"
})([""]);
HotelOffersList.propTypes = {
  onClick: _propTypes["default"].func.isRequired,
  offers: _propTypes["default"].arrayOf(_hotel.HotelOfferPropTypes).isRequired
};
var _default = exports["default"] = HotelOffersList;